<template>
  <div class="modal-card">
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless is-vcentered">
        <div class="is-circle button is-small is-static is-margin-left-xsmall">
          <span class="icon is-medium"><i class="fas fa-video"></i></span>
        </div>
        <div class="column is-padding-left-small">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">{{ params.title || 'Vidéo' }}</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <div class="">
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <div
          class="iframe-containerVideo"
          v-else>
          <youtube
            class="iframe-video"
            v-if="video.provider === 'youtube'"
            :video-id="video.video_id"
            ref="youtube"
            @ready="loading = false"></youtube>
          <vimeo-player
            class="iframe-video vimeo"
            v-if="video.provider === 'vimeo'"
            ref="vimeo"
            :video-id="video.video_id"
            @ready="loading = false"></vimeo-player>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'VideoPreview',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object
    },
    source: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    video () {
      return this.source
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style>
  .vimeo iframe {
    height: 100%;
    width: 100%;
  }
</style>
